<button
  data-testid="button"
  procure-button
  variant="stroked"
  [class]="[`favorite-button__button${small && '--small'}`, `favorite-button__button${light && '--light'}`]"
  [disabled]="disabled"
  [loading]="isSaving"
  (click)="toggleFavorite.emit(!isFavorite)"
>
  <mat-icon [class]="`favorite-button__icon${small && '--small'}`">
    {{ isFavorite ? "star" : "star_outline" }}
  </mat-icon>
</button>
